import { Button } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import styles from './styles.module.scss'

type BlockContactModalActionsProps = {
  contact?: Contact
  onConfirm?: () => void
  onCancel?: () => void
}

export const BlockContactModalActions = ({
  contact,
  onConfirm,
  onCancel,
}: BlockContactModalActionsProps) => {
  const isUnknowContact = !contact || contact.isUnknownContact
  return (
    <div className={styles.modalActions}>
      <Button
        onClick={onConfirm}
        size={'medium'}
        contained={'primary'}
        text={isUnknowContact ? 'Block and report spam' : 'Block contact'}
        fullWidth
      />
      <Button onClick={onCancel} size={'medium'} contained={'tertiary'} text='Cancel' fullWidth />
    </div>
  )
}
